import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function PublicNav() {
  const { user } = useAuth();
  const navigate = useNavigate();
  return (
    <header className="sticky top-0 z-40 bg-[#070707]/95 backdrop-blur border-b border-[#1f1f1f]">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 h-16 flex items-center justify-between">
        <Link to="/" className="font-display text-2xl tracking-wider" data-testid="public-logo">
          COACH<span className="text-[#d7ff00]">JP</span>
        </Link>
        <nav className="hidden md:flex items-center gap-7 font-mono-jp text-xs uppercase tracking-widest text-[#888]">
          <Link to="/about" className="hover:text-white" data-testid="nav-about">About</Link>
          <Link to="/features" className="hover:text-white" data-testid="nav-features">Features</Link>
          <Link to="/pricing" className="hover:text-white" data-testid="nav-pricing">Pricing</Link>
        </nav>
        <div className="flex items-center gap-2">
          {user ? (
            <button onClick={() => navigate(user.role === "admin" ? "/admin" : "/app/dashboard")} className="bg-[#d7ff00] text-black font-display tracking-wider uppercase px-4 py-2 text-sm hover:bg-white" data-testid="open-app">
              Open App
            </button>
          ) : (
            <>
              <Link to="/login" className="text-[#888] hover:text-white text-xs font-mono-jp uppercase tracking-widest" data-testid="open-login">Login</Link>
              <Link to="/pricing" className="bg-[#d7ff00] text-black font-display tracking-wider uppercase px-4 py-2 text-sm hover:bg-white" data-testid="open-pricing">Get Started</Link>
            </>
          )}
        </div>
      </div>
    </header>
  );
}
